import PopUp from '@/common/components/PopUp';
import React from 'react';
import { Form } from '../payoutSlip.styles';
import { Colors } from 'chart.js';
import SubmitButton from '@/common/components/buttons/SubmitButton';

const AddPayoutSlip = ({ setAddPayoutSlip, fileRef, hanldeAddFile }) => {
	return (
		<PopUp setShow={setAddPayoutSlip}>
			<Form onSubmit={(e) => hanldeAddFile(e)}>
				<input
					style={{ width: '350px', marginLeft: '30px' }}
					color={Colors.darkBlue}
					ref={fileRef}
					type='file'
					accept='application/pdf,image/jpg,image/png,image/jpeg'
					required
				/>
				<SubmitButton text='Save' style={{ width: '80px', height: '30px' }} />
			</Form>
		</PopUp>
	);
};

export default AddPayoutSlip;
